import { jsx as a, Fragment as f, jsxs as b } from "react/jsx-runtime";
import "react";
import { ImageCard as k } from "../ImageCard/ImageCard.js";
import { AdjustableTwoColumnGrid as y } from "../AdjustableTwoColumnGrid/AdjustableTwoColumnGrid.js";
import { Concat as l } from "../Concat/Concat.js";
import { StringList as o } from "../StringList/StringList.js";
import { ShowAboutContent as T } from "../ShowAboutContent/ShowAboutContent.js";
import { getHoursMinsStr as _, classes as S } from "../../utils/helpers.js";
import '../../assets/ShowAboutLayout.css';const A = {
  "series-about-tab": "_series-about-tab_cekq9_1"
};
function F({
  series: t,
  type: r = "series",
  showUpcoming: p = !1,
  nextAirdates: u = [],
  firstColumnWidth: c = "33%"
}) {
  var n, e;
  const i = t.cast.map((d) => d.real_name).join(", "), g = t != null && t.run_time ? _(t.run_time) : "", m = r === "series" ? ["TV Series", t.rating] : [t != null && t.year_released ? t == null ? void 0 : t.year_released : "Film", t.rating, g];
  return /* @__PURE__ */ a(f, { children: /* @__PURE__ */ b(y, { classname: S([A["series-about-tab"], "series-about-tab"]), firstColumnWidth: c, children: [
    t.detailImage === null ? /* @__PURE__ */ a(l, { list: [
      typeof t.genres == "string" ? t.genres : /* @__PURE__ */ a(o, { list: t.genres, separatorType: "comma", makeBlock: !0 }),
      /* @__PURE__ */ a(o, { list: m, separatorType: "pipe", makeBlock: !0 })
    ] }) : /* @__PURE__ */ a(
      k,
      {
        image: {
          url: (n = t.detailImage) == null ? void 0 : n.url,
          aspectRatio: (e = t.detailImage) == null ? void 0 : e.aspectRatio
        },
        content: /* @__PURE__ */ a(l, { list: [
          typeof t.genres == "string" ? t.genres : /* @__PURE__ */ a(o, { list: t.genres, separatorType: "comma", makeBlock: !0 }),
          /* @__PURE__ */ a(o, { list: m, separatorType: "pipe", makeBlock: !0 })
        ] })
      }
    ),
    /* @__PURE__ */ a(
      T,
      {
        series: t,
        showUpcoming: p,
        castStr: i,
        type: r,
        nextAirDates: u
      }
    )
  ] }) });
}
export {
  F as ShowAboutLayout,
  F as default
};
